import { useMutation } from "react-query";

import { t } from "@/i18n-js/instance";
import { useToast } from "@/react/components/SettingsApp/CompassCompat/Toast";
import { reactQueryPost } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import { commentCache } from "@/react/lib/queries/comments";
import type { Comment } from "@/react/types/Comment";
import { COMMENT_TYPE } from "@/react/types/FlaggedContent";

export interface ReportFormValues {
  reported_reason_body: string;
  reported_reason_type: string;
}

interface UseReportCommentParams {
  comment: Comment;
  onSuccess: () => void;
}

export const useReportComment = ({
  comment,
  onSuccess,
}: UseReportCommentParams) => {
  const { id, post_id: postId } = comment;
  const { success, error } = useToast();

  const { mutate: reportComment, isPending } = useMutation({
    mutationFn: (formData: ReportFormValues) =>
      reactQueryPost(internalApi.flaggedContent.create(), {
        flagged_content: {
          ...formData,
          flagged_contentable_id: id,
          flagged_contentable_type: COMMENT_TYPE,
        },
      }),
    onSuccess: () => {
      commentCache.update({
        postId,
        id,
        updater: current => ({
          ...current,
          unresolved_flagged_reports_count:
            current.unresolved_flagged_reports_count + 1,
        }),
      });
      onSuccess();
      success(t("comments.report.alerts.success"));
    },
    onError: () => {
      error(t("comments.report.alerts.failure"));
    },
  });

  return { reportComment, isPending };
};
